import { Component } from '@angular/core';
import { smoothlyMenu } from '../../../app.helpers';
import { Router, ActivatedRoute } from '@angular/router';
declare var jQuery: any;

import { AuthService } from '../../../auth.service';
import { UserService } from '../../../user.service';

// internacionalization
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { OnInit, OnDestroy } from '@angular/core';
import { AppConfiguration } from '../../../conf/app.configuration';
import { BaseComponent } from '../baseComponent/base.component';


@Component({
  selector: 'topnavbar',
  templateUrl: 'topnavbar.template.html'
  // ,providers: [AuthService]
})
export class TopnavbarComponent extends BaseComponent implements OnInit, OnDestroy {

  viewNotes = false;
  public activeLanguages: Array<string>;
  public activateLangChange = true;

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public userService: UserService,
    private appConfig: AppConfiguration
  ) {
    super();
    this.activeLanguages = this.appConfig.getValue('activeLanguages');
    if (!this.activeLanguages) {
      this.activeLanguages = ['es', 'ca', 'gl', 'eu'];
    }
  }

  changeLanguage(lang) {
    this.translate.use(lang);
  }

  changeColor(color) {
    if (color == 'BLUE') {
      jQuery('body').toggleClass('skin1', true);
      jQuery('body').toggleClass('skin2', false);
      jQuery('body').toggleClass('skin3', false);
    } else if (color == 'GREY') {
      jQuery('body').toggleClass('skin1', false);
      jQuery('body').toggleClass('skin2', true);
      jQuery('body').toggleClass('skin3', false);
    } else if (color == 'GREEN') {
      jQuery('body').toggleClass('skin1', false);
      jQuery('body').toggleClass('skin2', false);
      jQuery('body').toggleClass('skin3', true);
    } else {
      jQuery('body').toggleClass('skin1', false);
      jQuery('body').toggleClass('skin2', false);
      jQuery('body').toggleClass('skin3', false);
    }
  }

  isActive(lang): boolean {
    return this.translate.currentLang === lang;
  }

  ngOnInit() {
    // subscribe to router event
    this.subscribe(this.activatedRoute.queryParams,
      (param: any) => {
        let locale = param['locale'];
        if (locale !== undefined) {
          this.translate.use(locale);
        }
      }
    );
  }

  logout() {
    this.authService.logout();
  }

  toggleNavigation(): void {
    jQuery('body').toggleClass('mini-navbar');
    smoothlyMenu();
  }
  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }

  prefs() {
    this.router.navigate(['userPrefs']);
  }
}
